import { Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Observable } from 'rxjs';
import { BwletinMath } from '../../modelau/bwletin/bwletin';
import { ICanlyniadChwilio } from '../../modelau/canlyniad-chwilio';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class BwletinService {

  constructor(
    private apiService: ApiService
  ) { }

  get(id: number): Observable<Blob> {
    return this.apiService.get(`/bwletin/${id}`, undefined, 'blob' as 'json');
  }

  niferHebAgor(): Observable<any> {
    return this.apiService.get(`/bwletin/niferhebagor`);
  }

  niferHebAgorTab(mathBwletin: BwletinMath): Observable<any> {
    return this.apiService.get(`/bwletin/niferhebagortab/${mathBwletin}`);
  }

  chwilio(event: LazyLoadEvent): Observable<ICanlyniadChwilio> {
    return this.apiService.post(
      `/bwletin/chwilio`, event);
  }
}
